import { BB_NAVIGATE_HOME } from '../constants/webViewNavigateHome'
import { postHostPayload, pushRoute } from './reactNativeWebView'

/** Ask RN/iframe host to navigate to native Calendar (see useWebViewNavigateHomeMessage). */
export function postWebViewNavigateHomeMessage(): boolean {
  return postHostPayload({ type: BB_NAVIGATE_HOME })
}

/**
 * Sends the current view to Home via the RN host, otherwise `/` in the browser.
 * Returns true when the host accepted the message.
 */
export function navigateHomeOrNotifyHost(): boolean {
  if (postWebViewNavigateHomeMessage()) {
    return true
  }

  pushRoute('/')
  return false
}
